import AuthorProfile from './AuthorProfile'
import BlogCtaBlock from './BlogCtaBlock'

export { AuthorProfile }
export default { AuthorProfile, BlogCtaBlock }
